export default __webpack_public_path__ + "static/media/Digital Keys.20b84273.svg";